import { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { ApiEndpoints } from "../../helper/ApiEndpoints";
import ApiRequest from "../../helper/ApiRequest";
import { BaseUrl } from "../../helper/BaseUrl";
import CustomSelect from "../../component/CustomSelect";
import CustomImageUpload from "../../component/CustomImageUpload";
import DynamicCKEditor from "../../component/DynamicCkEditor";
import { toast } from "react-toastify";
import AdminHeader from "../../component/AdminHeader";

const blogEditEndpoint = ApiEndpoints.adminBlogs.blogEdit;
const blogUpdateEndpoint = ApiEndpoints.adminBlogs.blogUpdate;

export default function EditBlog() {
  const navigate = useNavigate();
  const { blog_id } = useParams();

  const [previews, setPreviews] = useState({ section_image: null, image: null,});

  const [postData, setPostData] = useState({ category_id: "", author_id: "", tag1: "", name: "", slug: "", description1: "",  designation:"",  quote: "",  description2: "", section_image: null, image: null, createdBy: "", date: new Date(),});

  // State variables
  const [data, setData] = useState({
    blog: {},
    categories: [],
    authors: [],
    tags: [],
  });

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await ApiRequest("GET", `${blogEditEndpoint}${blog_id}`,);
        setData(response);
        setPostData(response.blog);
        setPreviews((prev) => ({
          ...prev,
          section_image: BaseUrl + response.blog.section_image || prev.section_image,
          image: BaseUrl + response.blog.image || prev.image,
        }));

      } catch (error) {
        console.error("Error fetching blog data:", error);
      }
    };

    fetchData();
  }, [blog_id]);

  const handleChange = (e) => {
    const { name, value, files } = e.target;

    if (files) {
      const file = files[0];

      // Update the previews state
      setPreviews((prev) => ({
        ...prev,
        [name]: URL.createObjectURL(file),
      }));

      // Update the postData state
      setPostData((prev) => ({
        ...prev,
        [name]: file,
      }));
    } else {
      let updatedValue = value;
      if (name === "date") {
        updatedValue = new Date(value).toISOString();
      }
      setPostData((prev) => ({
        ...prev,
        [name]: updatedValue,
      }));
    }
  };

  const handleEditorChange = (key, data) => {
    setPostData((prevState) => ({
      ...prevState,
      [key]: data,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    for (const [key, value] of Object.entries(postData)) {
      if(key === "category_id" || key === "author_id" || key === "tag1" || key === "slug" || key === "name"  || key === "description1" || key === "description2" || key === "designation" || key === "createdBy" || key === "date"){
        if ((value === "" || value === null)) {
          toast.error(`The field "${key}" is mandatory.`);
          return;
        }
    }
    }
    const formData = new FormData();
    Object.entries(postData).forEach(([key, value]) => {
      formData.append(key, value);
    });

    try {
      const response = await ApiRequest("POST", blogUpdateEndpoint + blog_id, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      toast.success(response.message);
      navigate("/blog");
    } catch (error) {
      console.error("Error submitting form:", error);
    }
  };

  const pagename = {
    name: 'Blog Management',
    user: 'Admin',
    innerpage: 'Blog Management / Blog / Edit Blog'
  }

  return (
    <>
      <AdminHeader pagename={pagename}/>
     <div className="add-content-page">
        <form id="blogEdit" onSubmit={handleSubmit}>
          <div className="add-content-wrap">
            <div className="row">
              <div className="col-lg-6">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>title<small>*</small></label>
                  </div>
                  <input value={postData.name} onChange={handleChange} name="name" type="text" className="form-control" placeholder="Enter Title" />
                </div>
              </div>

              <div className="col-lg-6">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>slug<small>*</small> (add prefix "blog-" in slug)</label>
                  </div>
                  <input value={postData.slug} onChange={handleChange} name="slug" type="text" className="form-control" placeholder="Enter Slug" />
                </div>
              </div>

              <div className="col-lg-6">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>category<small>*</small></label>
                  </div>
                  <CustomSelect defaultValue={postData.category_id} onChange={handleChange} name={"category_id"} options={data.categories} placeholder="Select Category" />
                </div>
              </div>

              <div className="col-lg-6">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>Date<small>*</small></label>
                  </div>
                  <input value={postData.date ? new Date(postData.date).toISOString().split("T")[0] : ""} onChange={handleChange} name="date" type="date" className="form-control" />
                </div>
              </div>

              <div className="col-lg-6">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>Author Name<small>*</small></label>
                  </div>
                  <CustomSelect defaultValue={postData.author_id} onChange={handleChange} name="author_id" options={data.authors} placeholder="Select Author Name" />
                </div>
              </div>


                <div className="col-lg-6">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>Author Des<small>*</small></label>
                  </div>
                  <input onChange={handleChange} value={postData.designation}  className="form-control" placeholder="Designation" />
                </div>
              </div>

              <div className="col-lg-6">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>Tag Name<small>*</small></label>
                  </div>
                  <CustomSelect defaultValue={postData.tag1} onChange={handleChange} name="tag1" options={data.tags} placeholder="Select Tag Name" />
                </div>
              </div>
            </div>
          </div>

          <div className="add-content-wrap">
            <div className="row">
              <div className="col-lg-12">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>First Description<small>*</small></label>
                  </div>
                  <DynamicCKEditor data={postData.description1} onChange={(event, editor) => handleEditorChange("description1", editor.getData())} />
                </div>
              </div>
            </div>
          </div>


            <div className="add-content-wrap">
            <div className="row">
              <div className="col-lg-12">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>Quote <small></small></label>
                  </div>
                  <input value={postData.quote}  onChange={handleChange} name="quote" type="text" className="form-control" placeholder="Enter Quote" />
                </div>
              </div>
            </div>
          </div>

          <div className="add-content-wrap">
            <div className="row">
              <div className="col-lg-12">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>Second Description <small>*</small></label>
                  </div>
                  <DynamicCKEditor data={postData.description2} onChange={(event, editor) => handleEditorChange("description2", editor.getData())}/>
                </div>
              </div>
            </div>
          </div>

          <div className="add-content-wrap">
            <div className="row">
              <div className="col-lg-6">
                <div className="add-page-inputs input-add-image">
                  <div className="label-wrap-add">
                    <label>Banner Image (1608 × 660)<small>*</small></label>
                  </div>
                  <CustomImageUpload name="section_image"
                    // maxSize={100 * 1024} // 320KB
                    acceptedFormats={[".webp"]}
                    onImageChange={handleChange}
                    imagePreview={previews.section_image}
                  />
                </div>
              </div>

              <div className="col-lg-6">
                <div className="add-page-inputs input-add-image">
                  <div className="label-wrap-add">
                    <label>Listing Image (444 × 332)<small>*</small></label>
                  </div>
                  <CustomImageUpload name="image"
                    // maxSize={50 * 1024}
                    acceptedFormats={[".webp"]}
                    onImageChange={handleChange}
                    imagePreview={previews.image} />
                </div>
              </div>
            </div>
          </div>

        </form>

        <button type="submit" form="blogEdit" className="default-btn">publish <span></span></button>
      </div>
    </>
  );
}
